var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-header"},[_c('blog-banner',{attrs:{"heading":_vm.header.heading,"caption":_vm.header.caption,"image":_vm.header.image}}),_c('blog-breadcrumb',{attrs:{"id":"blog-breadcrumb"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }